import {RouteKey} from '../routing.enums';
import {Routes} from '../routing.config';
import isMatchRoute from './isMatchRoute';

function getCurrentRouteKey(): RouteKey | null {
  const currentPath = window.location.pathname;

  // find all matching routes
  const matchingRoutes = Object.entries(Routes)
    .filter(([_, routePath]) => isMatchRoute(routePath, currentPath))
    .map(([routeKey, routePath]) => ({
      routeKey: routeKey as RouteKey,
      routePath,
      partsCount: routePath.split('/').filter((part) => part.length > 0).length,
    }));

  // If no routes match, return null
  if (matchingRoutes.length === 0) {
    return null;
  }

  // sort by the number of parts in the route path
  const [mostSpecificMatchingRoute] = matchingRoutes.sort((a, b) => {
    return b.partsCount - a.partsCount;
  });

  return mostSpecificMatchingRoute.routeKey;
}

export default getCurrentRouteKey;
